'use client';
import { memo } from 'react';
import { Cherobackground } from '../Cherobackground';
import { useViewport } from '@/hooks/dom';
import { useViewportMetrics } from '@/hooks/dom';
import { Viewport } from '@/theme/breakpoints';
import { CheroControls } from './CheroControls';
import { CheroTeamsCarousel } from './CheroTeamsCarousel';
import { CheroText } from './CheroText';
import { getHeroContentWrapperStyle, getHeroRootStyle, } from './Chero.styles';
import type { CheroProps } from './Chero.types';
import { useHeroCarouselController } from './useHeroCarouselController';
import { useHeroSequence } from './useHeroSequence';
import { useHeroTeams } from './useHeroTeams';
import { useHeroTeamsVisibility } from './useHeroTeamsVisibility';
import { useHeroTelemetry } from './useHeroTelemetry';
export const Chero = memo(function Chero({ className, style, onTeamInspect, onTeamDeploy, onBuildYourOwn, onAllTeams, }: CheroProps) {
    const { viewport, loaded: viewportLoaded } = useViewport();
    const { vh: viewportHeightUnit } = useViewportMetrics();
    const isMobile = viewport === Viewport.Mobile;
    const { heroTeamsData, hasTeams, teamsLength, heroTeamsDataLength, teamsQueryStatus, } = useHeroTeams();
    const { isLogoReady, isWaveReady, isNavReady } = useHeroSequence({
        viewportLoaded,
    });
    const { isTeamsMounted, isTeamsSettled, isTeamsVisible, markTeamsSettled, } = useHeroTeamsVisibility({ hasTeams, viewportLoaded });
    const { carouselRef, handleCenteredTeamChange, handleDeploy, handleInspect, handleTeamSelect, handlePrevious, handleNext, } = useHeroCarouselController({
        isTeamsSettled,
        markTeamsSettled,
        onTeamDeploy,
        onTeamInspect,
    });
    const isControlsVisible = isNavReady && isTeamsVisible;
    useHeroTelemetry({
        viewportLoaded,
        hasTeams,
        isLogoReady,
        isWaveReady,
        isNavReady,
        isTeamsMounted,
        isTeamsSettled,
        isTeamsVisible,
        teamsLength,
        heroTeamsDataLength,
        teamsQueryStatus,
    });
    return (
      <div data-el="Chero/Root" style={getHeroRootStyle({ viewportHeightUnit, style })} className={className}>
        <Cherobackground delay={0} entranceReady={isWaveReady}/>

        <div style={getHeroContentWrapperStyle({ viewportHeightUnit })}>
          <CheroText isMobile={isMobile} isLogoReady={isLogoReady}/>
          <CheroTeamsCarousel carouselRef={carouselRef} heroTeamsData={heroTeamsData} isMobile={isMobile} isTeamsMounted={isTeamsMounted} isTeamsVisible={isTeamsVisible} onCenteredTeamChange={handleCenteredTeamChange} onTeamSelect={handleTeamSelect}/>
          <CheroControls isControlsVisible={isControlsVisible} isMobile={isMobile} isTeamsMounted={isTeamsMounted} onAllTeams={onAllTeams} onBuildYourOwn={onBuildYourOwn} onDeployTeam={handleDeploy} onInspectTeam={handleInspect} onNext={handleNext} onPrevious={handlePrevious}/>
        </div>
      </div>
    );
});
export type { CheroProps } from './Chero.types';
